
import { Form, Input, InputNumber, Radio, Rate, Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const RatePropsDefaults = {
    label: '',
    name: '',
    count: 5,
    allowHalf: false,
    allowClear: true,
    colorEmptyType: 'full',
    colorFullType: 'full',
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};

const CustomRate = styled(Rate)`
  .ant-rate-star-zero .ant-rate-star-first svg,
  .ant-rate-star-zero .ant-rate-star-second svg,
  .ant-rate-star-half .ant-rate-star-second svg,
  .ant-rate-star-focused .ant-rate-star-first svg,
  .ant-rate-star-focused .ant-rate-star-second svg, {
    fill: ${({$colorEmpty})=>($colorEmpty+' !important')};
  }

  .ant-rate-star-full .ant-rate-star-first svg,
  .ant-rate-star-full .ant-rate-star-second svg,
  .ant-rate-star-full.ant-rate-star-focused .ant-rate-star-first svg,
  .ant-rate-star-full.ant-rate-star-focused .ant-rate-star-second svg,
  .ant-rate-star-half .ant-rate-star-first svg, {
    fill: ${({$colorFull})=>($colorFull+' !important')};
  }

  &:hover .ant-rate-star:hover .ant-rate-star-first svg
  &:hover .ant-rate-star:hover .ant-rate-star-second svg {
    fill: ${({$colorFull})=>($colorFull+' !important')};
  }
`;

export const FormRate = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _bb, _cc, _dd, _ee;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var starStyle = {
        colorEmpty: (_bb = style === null || style === void 0 ? void 0 : style.colorEmpty) !== null && _bb !== void 0 ? _bb : undefined,
        colorFull: (_cc = style === null || style === void 0 ? void 0 : style.colorFull) !== null && _cc !== void 0 ? _cc : undefined,
        colorEmptyType: (_dd = style === null || style === void 0 ? void 0 : style.colorEmptyType) !== null && _dd !== void 0 ? _dd : undefined,
        colorFullType: (_ee = style === null || style === void 0 ? void 0 : style.colorFullType) !== null && _ee !== void 0 ? _ee : undefined,
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _n;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : RatePropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : RatePropsDefaults.name;
    var count = (_j = props === null || props === void 0 ? void 0 : props.count) !== null && _j !== void 0 ? _j : RatePropsDefaults.count;
    var allowHalf = (_i = props === null || props === void 0 ? void 0 : props.allowHalf) !== null && _i !== void 0 ? _i : RatePropsDefaults.allowHalf;
    var allowClear = (_m = props === null || props === void 0 ? void 0 : props.allowClear) !== null && _m !== void 0 ? _m : RatePropsDefaults.allowClear;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : RatePropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : RatePropsDefaults.visible;
    var disabled = (_n = props === null || props === void 0 ? void 0 : props.disabled) !== null && _n !== void 0 ? _n : RatePropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    
    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
    
    const [fieldHidden, setFieldHidden] = useState(false);
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
    }, [_a?.fieldSource])

    useEffect(()=>{
        //otherCustom: 后端传的其他数据，其中有displayOnly，hidden等字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    return !calVisible && !fieldHidden ? null : <div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            name={name}
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, requiredText}] : []}
        >
            <CustomRate 
                // $colorEmptyType={starStyle?.colorEmptyType}
                // $colorFullType={starStyle?.colorFullType}
                $colorEmpty={starStyle?.colorEmpty}
                $colorFull={starStyle?.colorFull}
                allowHalf={allowHalf}
                allowClear={allowClear}
                count={count}
                onChange={(val)=>{
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: val,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }}
                disabled={disabled}
            />
        </Form.Item>
    </div>;
}

